import { CalendarService } from '../../../../../services/calendar.service';
import { ITimeBlockComponentItem } from '../../../types/time-block-component-item-types';
import { TimeBlockStructureService } from '../../../time-block-structure/time-block-structure.service';
import { TimeBlockIntersectionService } from '../../intersection/time-block-intersection.service';
import { Slot } from '../slot/slot';
import { Injectable, inject } from '@angular/core';
import { SlotHandlerService } from '../../../../../../../core/services/features/fix-interval-planner/slot-handler.service';
import { Interval } from 'date-fns';
import { TimeBlockItemBuilderService } from '../../../generation/time-block-item-builder.service';
import { TimeBlockType } from '../../../types/time-block-types';

@Injectable()
export class ParallelTimeBlockWeekViewVariableIntervalCalculatorService {
  private readonly timeBlockStructureService = inject(TimeBlockStructureService);
  private readonly calendarService = inject(CalendarService);
  private readonly timeBlockIntersectionService = inject(TimeBlockIntersectionService);
  private readonly timeBlockItemBuilderService = inject(TimeBlockItemBuilderService);
  private readonly slotHandlerService = inject(SlotHandlerService);

  public calculate(): ITimeBlockComponentItem[] {
    const visibleRange: Interval = {
      start: this.calendarService.model.calendarProperties.visibleStartDate,
      end: this.calendarService.model.calendarProperties.visibleEndDate,
    };
    const visibleTimeBlocks = this.timeBlockStructureService.getTimeBlockMap(false, visibleRange);
    const perDay = new Map<string, Slot[]>();
    visibleTimeBlocks.forEach((timeBlocksPerDay: ITimeBlockComponentItem[], date: string) => {
      const verticalSlotsPerDay = new Array<Slot>();
      perDay.set(date, verticalSlotsPerDay);
      this.slotHandlerService.orderVariableIntervalTimeBlocksByStartDate(timeBlocksPerDay);
      timeBlocksPerDay
        .filter((timeBlock) => timeBlock.timeBlockModel.type === TimeBlockType.ExistingBlock)
        .forEach((timeBlock: ITimeBlockComponentItem) => {
          this.slotHandlerService.assignTimeBlockToSlot(
            timeBlock,
            verticalSlotsPerDay,
            this.timeBlockIntersectionService,
            false,
          );
        });
    });
    return this.updateGeometryVerticalSlots(perDay);
  }

  private updateGeometryVerticalSlots(perDay: Map<string, Slot[]>): ITimeBlockComponentItem[] {
    const updatedTimeBlocks = new Array<ITimeBlockComponentItem>();
    perDay.forEach((slotsPerDay: Slot[]) => {
      const slotCount = slotsPerDay.length;
      const percent = 100 / slotCount;
      for (let slotIndex = 0; slotIndex < slotCount; slotIndex++) {
        const slot = slotsPerDay[slotIndex];
        for (const timeBlock of slot.timeBlocks) {
          const timeBlockClone = timeBlock.clone(this.timeBlockItemBuilderService);
          const freeSlotCount = this.freeSlotCountAdjacentSlots(
            timeBlockClone,
            slotIndex + 1,
            slotsPerDay,
          );
          timeBlockClone.timeBlockModel.timeBlockViewType.geometryData.width =
            percent * (freeSlotCount + 1);
          timeBlockClone.timeBlockModel.timeBlockViewType.geometryData.containerLeftEdgeToTimeBlockLeftEdge =
            slotIndex * percent;
          updatedTimeBlocks.push(timeBlockClone);
        }
      }
    });
    return updatedTimeBlocks;
  }

  private freeSlotCountAdjacentSlots(
    timeBlock: ITimeBlockComponentItem,
    nextSlot: number,
    slotsPerDay: Slot[],
  ): number {
    let freeSlots = 0;
    for (let slotIndex = nextSlot; slotIndex < slotsPerDay.length; slotIndex++) {
      if (slotsPerDay[slotIndex].intersectsTimeBlock(timeBlock)) {
        break;
      }
      freeSlots++;
    }
    return freeSlots;
  }
}
